import React, { Component, Fragment } from 'react';

import { connect } from 'react-redux';
import { AxiosError } from 'axios';

import { setDeletedGuide } from '../actions/CityGuideActions';
import { CityGuideForm } from '../components/forms/CityGuideForm';
import { getConfig } from '../config';
import {
  getMatchByPath,
  getMixPanelEncodingTitle,
} from '../infrastructure/utils/common';
import { getByTag } from '../services/ActivitiesService';
import * as Service from '../services/CityGuideService';
import * as UserService from '../services/UsersService';
import { uploadImage } from '../api/ImageApi';
import Error from '../components/stateMessage/Error';
import Spinner from '../components/utils/Spinner';
import '../styles/containers/Activities.css';

const { batchWebURL } = getConfig();

class Guide {
  id = '';
  title = '';
  picture = '';
  text = '';
  dyk = '';
  city = '';
  published = '';
  popularity = '';
  entertainments = [];
  photos = [];
  cheatsheet = [];
  happenings = [];
  articles = [];
  activities = [];
  ambassador = '';
}

class State {
  city = '';
  isError = false;
  guide = new Guide();
  loaded = false;
  errorMessage = '';
}

interface CityGuideProps {
  history: any;
  router: any;
  setDeleted: (id: string) => void;
}

class CityGuide extends Component<CityGuideProps> {
  state = new State();

  async componentDidMount() {
    const { history } = this.props;
    const match = getMatchByPath(
      history.location.pathname,
      '/cities/guide/:city'
    );
    const { city } = match.params;
    try {
      const [
        activities,
        guides,
        entertainments,
        ambassadors,
      ] = await Promise.all([
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        getByTag(city),
        Service.getGuides(),
        Service.getEntertainmments(),
        UserService.getUsersByRole('ambassador'),
      ]);
      const cityGuide = guides.find(elem => elem.city === city);
      this.setState({
        city,
        activities,
        entertainments,
        ambassadors,
        guide: cityGuide || new Guide(),
        loaded: true,
      });
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  }

  hideMessage = () => {
    this.setState({ isError: false });
  };

  updateGuide = async guide => {
    try {
      const data = Service.putGuide(guide);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  deleteGuide = async guideId => {
    const { setDeleted } = this.props;
    try {
      Service.deleteGuide(guideId);
      setDeleted(guideId);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  updateEntertainment = async entertainment => {
    try {
      const data = Service.putEntertainment(entertainment);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  deleteEntertainment = async id => {
    try {
      Service.deleteEntertainment(id);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  getImageUrl = async (type, id) => {
    try {
      const data = Service.getUrlForImage(type, id);
      return data;
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  uploadImage = async (url, image) => {
    try {
      uploadImage(url, image);
    } catch (e) {
      const error = e as AxiosError;
      this.setState({
        isError: true,
        errorMessage: `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`,
      });
    } finally {
      setTimeout(this.hideMessage, 5 * 1000);
    }
  };

  toCityPage = () => {
    const { history } = this.props;
    history.push('/cities');
  };

  getCityGuideActions = guide => [
    {
      label: 'Copy City Guide deep-link',
      image: { src: '/copy-icon.svg', alt: 'page-deep-link', width: '20px' },
      type: 'link',
      href: `${batchWebURL}/city-guide/${guide.city}`,
      show: !!guide.city,
    },
    {
      label: 'View top user actions',
      image: { src: '/mixpanel-short.png', alt: 'mixpanel' },
      type: 'link',
      href: `https://mixpanel.com/report/1726253/view/18560/insights#~(columnWidths~(bar~())~displayOptions~(chartType~'line~plotStyle~'standard~analysis~'linear~value~'absolute)~sorting~(bar~(sortBy~'column~colSortAttrs~(~(sortBy~'value~sortOrder~'desc)))~line~(sortBy~'value~sortOrder~'desc)~table~(sortBy~'column~colSortAttrs~(~(sortBy~'label~sortOrder~'asc))))~timeComparison~null~title~'~querySamplingEnabled~false~sections~(show~(~(dataset~'!mixpanel~value~(name~'cityGuidePageViewed~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'cityName~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        guide.city
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'cityName*20equals*20${getMixPanelEncodingTitle(
        guide.city
      )})~(dataset~'!mixpanel~value~(name~'cityGuideProductClicked~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'productCity~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        guide.city
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'productCity*20equals*20${getMixPanelEncodingTitle(
        guide.city
      )})~(dataset~'!mixpanel~value~(name~'cityGuideLinkClicked~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'cityName~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        guide.city
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'cityName*20equals*20${getMixPanelEncodingTitle(
        guide.city
      )})~(dataset~'!mixpanel~value~(name~'cityGuideShareTapped~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~math~'total~perUserAggregation~null~property~null))~time~(~(dateRangeType~'in*20the*20last~unit~'day~window~(value~30~unit~'day))))~legend~())`,
      show: !!guide.city,
    },
    {
      label: 'View top activities',
      image: { src: '/mixpanel-short.png', alt: 'mixpanel' },
      type: 'link',
      /* eslint-disable-next-line max-len */
      href: `https://mixpanel.com/report/1726253/view/18560/insights#~(columnWidths~(bar~())~displayOptions~(chartType~'bar~plotStyle~'standard~analysis~'linear~value~'absolute)~sorting~(bar~(sortBy~'column~colSortAttrs~(~(sortBy~'value~sortOrder~'desc)~(sortBy~'value~sortOrder~'desc)))~line~(sortBy~'value~sortOrder~'desc)~table~(sortBy~'column~colSortAttrs~(~(sortBy~'label~sortOrder~'asc)~(sortBy~'label~sortOrder~'asc))))~timeComparison~null~title~'~querySamplingEnabled~false~sections~(show~(~(dataset~'!mixpanel~value~(name~'cityGuideProductClicked~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'productCity~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        guide.city
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'productCity*20equals*20${getMixPanelEncodingTitle(
        guide.city
      )}))~group~(~(dataset~'!mixpanel~value~'productName~resourceType~'events~profileType~null~search~'~dataGroupId~null~propertyType~'string~typeCast~null~unit~null))~time~(~(dateRangeType~'in*20the*20last~unit~'day~window~(unit~'day~value~30))))~legend~())`,
      show: !!guide.city,
    },
    {
      label: 'View top links',
      image: { src: '/mixpanel-short.png', alt: 'mixpanel' },
      type: 'link',
      /* eslint-disable-next-line max-len */
      href: `https://mixpanel.com/report/1726253/view/18560/insights#~(columnWidths~(bar~())~displayOptions~(chartType~'bar~plotStyle~'standard~analysis~'linear~value~'absolute)~sorting~(bar~(sortBy~'column~colSortAttrs~(~(sortBy~'value~sortOrder~'desc)~(sortBy~'value~sortOrder~'desc)))~line~(sortBy~'value~sortOrder~'desc)~table~(sortBy~'column~colSortAttrs~(~(sortBy~'label~sortOrder~'asc)~(sortBy~'label~sortOrder~'asc))))~timeComparison~null~title~'~querySamplingEnabled~false~sections~(show~(~(dataset~'!mixpanel~value~(name~'cityGuideLinkClicked~resourceType~'events)~resourceType~'events~profileType~null~search~'~dataGroupId~null~filter~(~(dataset~'!mixpanel~value~'cityName~resourceType~'events~profileType~null~search~'~dataGroupId~null~filterType~'string~defaultType~'string~filterOperator~'equals~filterValue~(~'${getMixPanelEncodingTitle(
        guide.city
      )})~propertyObjectKey~null~determiner~'all))~math~'total~perUserAggregation~null~property~null~filterDeterminer~'all~labelSuffix~'cityName*20equals*20${getMixPanelEncodingTitle(
        guide.city
      )}))~group~(~(dataset~'!mixpanel~value~'linkName~resourceType~'events~profileType~null~search~'~dataGroupId~null~propertyType~'string~typeCast~null~unit~null))~time~(~(dateRangeType~'in*20the*20last~unit~'day~window~(unit~'day~value~30))))~legend~())`,
      show: !!guide.city,
    },
  ];

  render() {
    const guideActions = {
      update: this.updateGuide,
      delete: this.deleteGuide,
      updateEntertainment: this.updateEntertainment,
      deleteEntertainment: this.deleteEntertainment,
      getUrlForImage: this.getImageUrl,
      uploadImage: this.uploadImage,
    };
    const {
      guide,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      entertainments,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activities,
      isError,
      errorMessage,
      loaded,
      city,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      ambassadors,
    } = this.state;
    const { history, router } = this.props;
    if (!loaded) {
      return <Spinner />;
    }
    return (
      <Fragment>
        {isError && <Error text={errorMessage} />}
        <CityGuideForm
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          guide={guide}
          city={city}
          router={router}
          history={history}
          actions={guideActions}
          toCityPage={this.toCityPage}
          activities={activities}
          ambassadors={ambassadors}
          entertainments={entertainments}
          cityGuideActions={this.getCityGuideActions(guide)}
        />
      </Fragment>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setDeleted: guide => dispatch(setDeletedGuide(guide)),
  };
}

export default connect(null, mapDispatchToProps)(CityGuide);
